import { get, post, patch } from './requests'

export const getInspectionBudgets = key => params =>
  get(['inspection-budgets'], {
    key,
    transformPayload: true,
    params,
  })

export const getInspectionBudgetById = key => id =>
  get(['inspection-budgets', id], { key, transformPayload: true })

export const getAiInspectionData = (key, payload) =>
  post(
    ['inspection-budgets', 'generate-ai-inspection-data'],
    { key, transformPayload: true },
    payload
  )

export const createInspectionBudget = (key, payload) =>
  post(['inspection-budgets'], { key, transformPayload: true }, payload)

export const updateInspectionBudget = (key, id, payload) =>
  patch(['inspection-budgets', id], { key, transformPayload: true }, payload)

export const duplicateInspectionBudget = (key, id, payload) =>
  post(['inspection-budgets', id, 'duplicate'], { key, transformPayload: true }, payload)

export const getInspectionTradesmen = key => params =>
  get(['inspection-tradesmen'], {
    key,
    transformPayload: true,
    params,
  })

export const createInspectionTradesman = (key, payload) => {
  const shouldTransformIntoFormData = payload?.logo instanceof File || payload?.logo instanceof Blob

  return post(
    ['inspection-tradesmen'],
    {
      key,
      transformPayload: true,
      transformFormData: shouldTransformIntoFormData,
      formData: shouldTransformIntoFormData,
    },
    payload
  )
}

export const getInspectionTradesmanById = (key, id) =>
  get(['inspection-tradesmen', id], { key, transformPayload: true })

export const updateInspectionTradesman = (key, id, payload) => {
  const shouldTransformIntoFormData =
    payload?.logo instanceof File || payload?.logo instanceof Blob || payload?.logo === null

  return patch(
    ['inspection-tradesmen', id],
    {
      key,
      transformPayload: true,
      transformFormData: shouldTransformIntoFormData,
      formData: shouldTransformIntoFormData,
    },
    payload
  )
}

export const getInspectionBudgetResolutionMaterialUnids = key => params =>
  get(['inspection-budget-resolution-material-unids'], {
    key,
    transformPayload: true,
    params,
  })

export const downloadInspectionBudgetPdf = (key, id, options = {}) =>
  get(['inspection-budgets', id, 'inspection_budget_pdf_download'], {
    key,
    responseType: 'blob',
    transformPayload: false,
    params: options?.exportMode ? { export_mode: options.exportMode } : undefined,
  })
